import { render } from "./Attachments.vue?vue&type=template&id=2a67c347&scoped=true"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"

import "./Attachments.vue?vue&type=style&index=0&id=2a67c347&scoped=true&lang=scss"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a67c347"]])

export default __exports__